// extracted by mini-css-extract-plugin
module.exports = {"check-email__heading":"CheckEmail_check-email__heading___KdQ8","check-email__summary":"CheckEmail_check-email__summary__S6A_W"};